import React, { useEffect, useState, useRef } from "react";
import { Helmet } from "react-helmet-async";
import classNames from "classnames";
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import { useHistory, Link } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import axios from "axios";
import { localApi, credentials } from "utils/headApi";

import NavPills from "components/NavPills/NavPills.js";
import EmailIcon from "@material-ui/icons/Email";
import PhoneAndroidIcon from "@material-ui/icons/PhoneAndroid";
import CustomInput from "components/CustomInput/CustomInput.js";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import CircularProgress from "@material-ui/core/CircularProgress";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Parallax from "components/Parallax/Parallax.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import Button from "components/CustomButtons/Button.js";
import Slide from "@material-ui/core/Slide";
import { FiPhoneCall } from "react-icons/fi";
import Popover from "@material-ui/core/Popover";

import productStyle from "assets/jss/material-kit-pro-react/views/productStyle.js";
import aboutUsStyle from "assets/jss/material-kit-pro-react/views/blogPostsPageStyle.js";

import InshaHeader from "views/InshaBanglesPage/Section/InshaHeader";
import InshaHeaderLink from "views/InshaBanglesPage/Section/InshaHeaderLink";
import Footer from "views/InshaBanglesPage/Section/InshaFooter";
import popOver from "assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.js";

import {
  Favorite,
  FavoriteBorder,
  ChatBubbleOutline,
  Repeat,
  ShareOutlined,
  Phone,
  WhatsApp,
  Bookmark,
  BookmarkBorder,
  MoreHoriz,
  Send,
  Delete,
  Close,
} from "@material-ui/icons";

const useStyles = makeStyles(productStyle);
const useStyle = makeStyles(aboutUsStyle);
const useStylPop = makeStyles(popOver);

const getInitials = (company) => {
  if (!company || typeof company !== "string") {
    return "?";
  }

  const words = company.trim().split(/\s+/).filter(Boolean);

  if (words.length === 0) {
    return "?";
  }

  if (words.length === 1) {
    return words[0].substring(0, 2).toUpperCase();
  }

  return `${words[0].charAt(0)}${words[1].charAt(0)}`.toUpperCase();
};

const AvatarFallback = ({ company, style }) => {
  return (
    <div
      aria-label={company || "Company avatar"}
      title={company || "Company"}
      style={{
        width: 40,
        height: 40,
        minWidth: 40,
        borderRadius: "50%",
        marginRight: 12,
        border: "1px solid #eeeeee",
        backgroundColor: "#e0e0e0",
        color: "#262626",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 14,
        fontWeight: 700,
        overflow: "hidden",
        ...style,
      }}
    >
      {getInitials(company)}
    </div>
  );
};

const AvatarImage = ({ src, company }) => {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(false);
  }, [src]);

  if (!src || hasError) {
    return <AvatarFallback company={company} />;
  }

  return (
    <img
      src={src}
      alt={company || "Company avatar"}
      title={company || "Company"}
      style={{
        width: 40,
        height: 40,
        minWidth: 40,
        borderRadius: "50%",
        marginRight: 12,
        objectFit: "cover",
        border: "1px solid #eeeeee",
      }}
      onError={() => setHasError(true)}
    />
  );
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function OfferList() {
  const [posts, setPosts] = useState([]);
  const [ribbonColors, setRibbonColors] = useState({});
  const [loginModal, setLoginModal] = React.useState(false);

  const [mobile, setMobile] = React.useState("");
  const [mobileErr, setMobileErr] = React.useState("");
  const [otpNumber, setOtpNumber] = React.useState("");
  const [otpNumberErr, setOtpNumberErr] = React.useState("");
  const [otpScreen, setOtpScreen] = React.useState(false);
  const [otp, setOtp] = React.useState("");

  const [reSend, setReSend] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [emailErr, setEmailErr] = React.useState("");
  const [admin, setAdmin] = React.useState([]);
  const [register, setRegister] = React.useState("");
  const [registerClient, setRegisterClient] = React.useState("");

  const [emailConfirm, setEmailConfirm] = React.useState("");
  const [emailConfirmErr, setEmailConfirmErr] = React.useState("");

  const [otpMpin, setOtpMpin] = React.useState("");
  const [forgotPass, setForgotPass] = React.useState(false);
  const [otpConfirm, setOtpConfirm] = React.useState(false);
  const [updatePassword, setUpdatePassword] = React.useState(false);

  const [password, setPassword] = useState(["", "", "", "", "", ""]);
  const [passwordErr, setPasswordErr] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState([
    "",
    "",
    "",
    "",
    "",
    "",
  ]);
  const [passwordConfirmErr, setPasswordConfirmErr] = useState("");
  const [updatePasswordConfirm, setUpdatePasswordConfirm] = useState([
    "",
    "",
    "",
    "",
    "",
    "",
  ]);
  const [updatePasswordConfirmErr, setUpdatePasswordConfirmErr] = useState("");

  /*
  |--------------------------------------------------------------------------
  | Comment states
  |--------------------------------------------------------------------------
  */

  const [commentModalOpen, setCommentModalOpen] = useState(false);
  const [selectedPost, setSelectedPost] = useState(null);
  const [commentText, setCommentText] = useState("");
  const [commentSaving, setCommentSaving] = useState(false);
  const [commentDeleting, setCommentDeleting] = useState(null);
  const [commentError, setCommentError] = useState("");

  // ✅ Refs - separate for each section
  const inputs = useRef([]); // Login / OTP input refs
  const inputsConfirm = useRef([]); // Confirm Code input refs
  const inputsUpdate = useRef([]); // Update mPIN input refs

  // Initialize refs only once
  useEffect(() => {
    inputs.current = Array(6)
      .fill()
      .map((_, i) => inputs.current[i] || React.createRef());
    inputsConfirm.current = Array(6)
      .fill()
      .map((_, i) => inputsConfirm.current[i] || React.createRef());
    inputsUpdate.current = Array(6)
      .fill()
      .map((_, i) => inputsUpdate.current[i] || React.createRef());
  }, []);

  const classes = useStyles();
  const classe = useStyle();
  const history = useHistory();
  const classPop = useStylPop();

  const activeSession = sessionStorage.getItem("sessionData");
  const userObj = JSON.parse(sessionStorage.getItem("sessionData"));

  const currentUrl = "https://indianbangles.in/offer-List";

  const seoTitle = "Ready Stock Bangles | INDIAN BANGLES";

  const seoDescription =
    "Explore ready stock bangles and imitation jewellery from INDIAN BANGLES. Find elegant designs, multiple sizes, and factory-price products available for immediate order.";

  const seoKeywords =
    "ready stock bangles, bangles in stock, imitation jewellery stock, gold plated bangles, wholesale bangles, INDIAN BANGLES";

  const ogImage =
    "https://indianbangles.in/imgstore/original_logo/IndianBanglesImgLogo.png";

  const stockSchema = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: "Ready Stock Bangles",
    url: currentUrl,
    description: seoDescription,
    publisher: {
      "@type": "Organization",
      name: "INDIAN BANGLES",
      logo: {
        "@type": "ImageObject",
        url: ogImage,
      },
    },
  };

  useEffect(() => {
    const userObj = JSON.parse(sessionStorage.getItem("sessionData") || "null");

    if (userObj === null) {
      const timer = setTimeout(() => {
        setLoginModal(true);
      }, 30000); // 30 seconds

      return () => clearTimeout(timer);
    }
  }, []);

  /*
  |--------------------------------------------------------------------------
  | Fetch posts
  |--------------------------------------------------------------------------
  */

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const sessionData = sessionStorage.getItem("sessionData");
        const userObj = sessionData ? JSON.parse(sessionData) : null;

        const api =
          userObj?.id && userObj?.admin?.id
            ? `${localApi}/posts/list/byAdminId/${userObj.admin.id}/byRegisterId/${userObj.id}`
            : `${localApi}/posts/list/byAdminId/2`;

        // console.log("Calling API:", api);

        const result = await fetch(api, {
          method: "GET",
          headers: {
            Authorization: `Basic ${credentials}`,
            "Content-Type": "application/json",
          },
        });

        if (!result.ok) {
          throw new Error(`API Error: ${result.status}`);
        }

        const getResult = await result.json();

        setPosts(getResult);
      } catch (error) {
        console.error("Error fetching posts:", error);
        setPosts([]);
      }
    };

    fetchPosts();
  }, []);

  async function getAdmin() {
    const api = localApi + `/admin/allList`;
    const result = await fetch(api, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const getResult = await result.json();
    // console.log(getResult.AdminList);
    setAdmin(getResult.AdminList);
  }

  async function getRegister() {
    const api = localApi + `/register/allList`;
    const result = await fetch(api, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const getResult = await result.json();
    // console.log(getResult.AdminList);
    setRegister(getResult.ClientList);
  }

  async function getRegisterClient() {
    const api = localApi + `/clientGroup/allList`;
    const result = await fetch(api, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const getResult = await result.json();
    // console.log(getResult.AdminList);
    setRegisterClient(getResult.ClientList);
  }

  useEffect(() => {
    getAdmin();
    getRegister();
    getRegisterClient();
  }, []);

  // ✅ Password change handlers
  const handlePasswordChange = (text, index) => {
    if (/^\d?$/.test(text)) {
      const updated = [...password];
      updated[index] = text;
      setPassword(updated);

      if (text && index < 5) {
        inputs.current[index + 1] && inputs.current[index + 1].focus();
      }
    }
  };

  const handleKeyPress = (e, index) => {
    if (e.key === "Backspace" && !password[index] && index > 0) {
      inputs.current[index - 1] && inputs.current[index - 1].focus();
    }
  };

  // ✅ Confirm Code handlers
  const handlePasswordChangeConfirm = (text, index) => {
    if (/^\d?$/.test(text)) {
      const updated = [...passwordConfirm];
      updated[index] = text;
      setPasswordConfirm(updated);

      if (text && index < 5) {
        inputsConfirm.current[index + 1] &&
          inputsConfirm.current[index + 1].focus();
      }
    }
  };

  const handleKeyPressConfirm = (e, index) => {
    if (e.key === "Backspace" && !passwordConfirm[index] && index > 0) {
      inputsConfirm.current[index - 1] &&
        inputsConfirm.current[index - 1].focus();
    }
  };

  // ✅ Update Password handlers
  const handlePasswordChangeConfirmUpdate = (text, index) => {
    if (/^\d?$/.test(text)) {
      const updated = [...updatePasswordConfirm];
      updated[index] = text;
      setUpdatePasswordConfirm(updated);

      if (text && index < 5) {
        inputsUpdate.current[index + 1] &&
          inputsUpdate.current[index + 1].focus();
      }
    }
  };

  const handleKeyPressConfirmUpdate = (e, index) => {
    if (e.key === "Backspace" && !updatePasswordConfirm[index] && index > 0) {
      inputsUpdate.current[index - 1] &&
        inputsUpdate.current[index - 1].focus();
    }
  };

  const PHONE_RULES = {
    in: 12, // India 91 + 10
    us: 11, // USA 1 + 10
    ca: 11, // Canada
    mx: 12, // Mexico
    br: 13, // Brazil
    ar: 12, // Argentina

    uk: 12, // United Kingdom 44 + 10
    fr: 11, // France
    de: 12, // Germany
    it: 12, // Italy
    es: 12, // Spain
    nl: 11, // Netherlands
    be: 11, // Belgium
    ch: 11, // Switzerland
    at: 11, // Austria
    se: 11, // Sweden
    no: 11, // Norway
    dk: 10, // Denmark
    fi: 11, // Finland
    ie: 11, // Ireland
    pt: 12, // Portugal
    pl: 11, // Poland
    cz: 12, // Czech
    hu: 11, // Hungary
    ro: 12, // Romania
    bg: 12, // Bulgaria
    gr: 12, // Greece
    ru: 11, // Russia
    ua: 12, // Ukraine

    ae: 12, // UAE 971 + 9
    sa: 12, // Saudi Arabia
    qa: 11, // Qatar
    kw: 11, // Kuwait
    om: 11, // Oman
    bh: 11, // Bahrain
    jo: 12, // Jordan
    lb: 11, // Lebanon
    il: 12, // Israel
    tr: 12, // Turkey
    ir: 12, // Iran
    iq: 13, // Iraq

    cn: 13, // China
    jp: 11, // Japan
    kr: 11, // South Korea
    sg: 10, // Singapore
    my: 11, // Malaysia
    th: 11, // Thailand
    id: 12, // Indonesia
    ph: 12, // Philippines
    vn: 11, // Vietnam
    hk: 11, // Hong Kong
    tw: 11, // Taiwan

    au: 11, // Australia
    nz: 11, // New Zealand

    za: 11, // South Africa
    ng: 13, // Nigeria
    ke: 12, // Kenya
    eg: 12, // Egypt
    ma: 12, // Morocco
    gh: 12, // Ghana
  };

  const handleMobileNumber = (mobile, country) => {
    setMobile(mobile);
    setMobileErr("");

    const rule = PHONE_RULES[country];

    // ❌ stop API calls for incomplete numbers
    if (!rule || mobile.length !== rule.totalLength) {
      return;
    }

    fetch(localApi + `/register/find/byMobile/${mobile}`, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    })
      .then(async (res) => {
        if (res.status === 404) {
          setMobileErr("Your number is not registered");
          return null;
        }
        if (!res.ok) throw new Error("Server error");
        return res.json();
      })
      .then((result) => {
        if (!result) return;

        if (result.message === "Mobile No. Already Registered") {
          setMobileErr("");
        } else {
          setMobileErr(result.message);
        }
      })
      .catch(console.log);
  };

  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
  };

  const handleEmail = (e) => {
    const value = e.target.value.trim();
    setEmail(value);
    setEmailErr("");

    // 🔴 empty field
    if (!value) {
      setEmailErr("Email is required");
      return;
    }

    // 🔴 invalid format
    if (!isValidEmail(value)) {
      setEmailErr("Please enter a valid email address");
      return;
    }

    // ✅ only valid email reaches API
    fetch(`${localApi}/register/find/byEmail/${value}`, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    })
      .then(async (res) => {
        if (res.status === 404) {
          setEmailErr("Your email is not registered");
          return null;
        }
        if (!res.ok) throw new Error("Server error");
        return res.json();
      })
      .then((result) => {
        if (!result) return;

        if (result.message === "Email ID Already Registered") {
          setEmailErr("");
        } else {
          setEmailErr(result.message);
        }
      })
      .catch((err) => console.log(err));
  };

  const handleEmailConfirm = (e) => {
    const { value } = e.target;
    setEmailConfirm(value);

    // ❌ stop if empty
    if (!value) return;

    // ❌ stop if invalid email format
    if (!isValidEmail(value)) {
      setEmailConfirmErr("Please enter a valid email address");
      return;
    }

    if (value) {
      fetch(localApi + `/register/find/byEmail/${value}`, {
        method: "GET",
        headers: {
          Authorization: `Basic ${credentials}`,
        },
      })
        .then(async (res) => {
          // ✅ prevent 404 console error
          if (res.status === 404) {
            return { message: "Not Found" };
          }
          return res.json();
        })
        .then((result) => {
          // 🔁 SAME conditions as your original code
          if (result.message === "Email ID Already Registered") {
            setEmailConfirmErr("");
          } else if (result.message === "Not Found") {
            setEmailConfirmErr("Your Email Not Registered");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const handleOtp = (e) => {
    // console.log(e.target.value);
    setOtpNumber(e.target.value);
    setOtpNumberErr("");
  };

  const handleSendOtpWithMobile = async () => {
    const getFindAdmin = admin?.find(
      (f) => f.websitename === "indianbangles.in",
    );
    const api = localApi + `/register/byMobile/${mobile}`;
    const result = await fetch(api, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const getResult = await result.json();
    let errorCount = 0;
    if (mobile === "" || !mobile) {
      errorCount++;
      setMobileErr("Mobile Number is Invalid");
    }
    if (errorCount === 0) {
      fetch(
        localApi +
          `/otp/send/byMobile?mobile=${mobile}&templateID=1207161762762132153`,
        {
          method: "PUT",
          headers: {
            "content-type": "application/json",
            accept: "application/json",
            Authorization: `Basic ${credentials}`,
          },
          body: JSON.stringify({
            websitename: "indianbangles.in",
            followId: getFindAdmin.id,
            adminId: getResult.aId,
          }),
        },
      )
        .then((response) => response.json())
        .then((response) => {
          // console.log(response);
          setMobileErr(response.message);
          if (response && response.error === true) {
            setOtpScreen({ otpScreen: true });
            setOtp(response.message);
            setOtpMpin("OTP");
          }
          // "Sender Not Found to +919967457786"
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleSendPasswordWithMobile = async () => {
    // console.log("okkkk");
    const getFindAdmin = admin?.find(
      (f) => f.websitename === "indianbangles.in",
    );
    const api = localApi + `/register/byMobile/${mobile}`;
    const result = await fetch(api, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const getResult = await result.json();
    let errorCount = 0;
    if (mobile === "" || !mobile) {
      errorCount++;
      setMobileErr("Mobile Number is Invalid");
    }
    if (errorCount === 0) {
      fetch(
        localApi +
          `/register/password/send/byMobile?mobile=${mobile}&templateID=1207161762762132153`,
        {
          method: "PUT",
          headers: {
            "content-type": "application/json",
            accept: "application/json",
            Authorization: `Basic ${credentials}`,
          },
          body: JSON.stringify({
            websitename: "indianbangles.in",
            followId: getFindAdmin.id,
            adminId: getResult.aId,
          }),
        },
      )
        .then((response) => response.json())
        .then((response) => {
          // console.log(response);
          setMobileErr(response.message);
          if (response && response.error === true) {
            setOtpScreen({ otpScreen: true });
            setOtp(response.message);
            setOtpMpin("mPIN");
          }
          // "Sender Not Found to +919967457786"
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleSendOtpWithEmail = async () => {
    const getFindAdmin = admin?.find(
      (f) => f.websitename === "indianbangles.in",
    );
    const api = localApi + `/register/byEmail/${email}`;
    const result = await fetch(api, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const getResult = await result.json();
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Basic ${credentials}`,
      },
      body: JSON.stringify({
        to: email,
        subject: "API CREATION SUBJECT",
        websitename: "indianbangles.in",
        followId: getFindAdmin.id,
        adminId: getResult.aId,
      }),
    };
    fetch(
      localApi + `/otp/send/byEmail?e=noreply@indianbangles.in`,
      requestOptions,
    )
      .then((response) => response.json())
      .then((response) => {
        // console.log(response);
        setEmailErr(response.message);
        if (response && response.error === true) {
          setOtpScreen({ otpScreen: true });
          setOtp(response.message);
          setOtpMpin("OTP");
        }
        // "Sender Not Found to +919967457786"
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleLoginWithMobile = () => {
    let errorCount = 0;
    const passwordString = password.join("");
    if (
      passwordString === "" ||
      !passwordString ||
      passwordString.length !== 6
    ) {
      errorCount++;
      setOtpNumberErr("OTP must be exactly 6 digits.");
    }
    if (errorCount === 0) {
      fetch(
        localApi +
          `/register/recieved/byMobile?mobile=${mobile}&otp=${passwordString}`,
        {
          method: "PUT",

          headers: {
            "content-type": "application/json",
            accept: "application/json",
            Authorization: `Basic ${credentials}`,
          },
        },
      )
        .then((response) => response.json())
        .then((response) => {
          // console.log(response);
          setOtpNumberErr(response.message);
          if (response.errorDetails.error === true) {
            const userObj = response.registerSession;
            localStorage.setItem("userObj", JSON.stringify(userObj));
            sessionStorage.setItem("sessionData", JSON.stringify(userObj));
            setLoginModal(false);
            window.location.reload(false);
          }
          // if (response.apiResponse.error !== "false") return false;
          // const userObj = response.user;
          // localStorage.setItem("userObj", JSON.stringify(userObj));
          // sessionStorage.setItem("sessionData", JSON.stringify(userObj));
          // history.push("/admin/dashboard");
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleLoginWithMobilePassword = () => {
    let errorCount = 0;
    const passwordString = password.join("");
    if (
      passwordString === "" ||
      !passwordString ||
      passwordString.length !== 6
    ) {
      errorCount++;
      setOtpNumberErr("OTP must be exactly 6 digits.");
    }
    if (errorCount === 0) {
      fetch(
        localApi +
          `/register/recieved/byMobilePassword?mobile=${mobile}&password=${passwordString}`,
        {
          method: "PUT",

          headers: {
            "content-type": "application/json",
            accept: "application/json",
            Authorization: `Basic ${credentials}`,
          },
        },
      )
        .then((response) => response.json())
        .then((response) => {
          // console.log(response);
          setOtpNumberErr(response.message);
          if (response.errorDetails.error === true) {
            const userObj = response.registerSession;
            localStorage.setItem("userObj", JSON.stringify(userObj));
            sessionStorage.setItem("sessionData", JSON.stringify(userObj));
            setLoginModal(false);
            window.location.reload(false);
          }
          // if (response.apiResponse.error !== "false") return false;
          // const userObj = response.user;
          // localStorage.setItem("userObj", JSON.stringify(userObj));
          // sessionStorage.setItem("sessionData", JSON.stringify(userObj));
          // history.push("/admin/dashboard");
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleLoginWithEmail = () => {
    let errorCount = 0;
    const passwordString = password.join("");
    if (
      passwordString === "" ||
      !passwordString ||
      passwordString.length !== 6
    ) {
      errorCount++;
      setOtpNumberErr("Enter Otp Number");
    }
    if (errorCount === 0) {
      fetch(
        localApi +
          `/register/recieved/byEmail?email=${email}&otp=${passwordString}`,
        {
          method: "PUT",

          headers: {
            "content-type": "application/json",
            accept: "application/json",
            Authorization: `Basic ${credentials}`,
          },
        },
      )
        .then((response) => response.json())
        .then((response) => {
          // console.log(response);
          setOtpNumberErr(response.message);
          if (response.errorDetails.error === true) {
            const userObj = response.registerSession;
            localStorage.setItem("userObj", JSON.stringify(userObj));
            sessionStorage.setItem("sessionData", JSON.stringify(userObj));
            setLoginModal(false);
            window.location.reload(false);
          }
          // if (response.apiResponse.error !== "false") return false;
          // const userObj = response.user;
          // localStorage.setItem("userObj", JSON.stringify(userObj));
          // sessionStorage.setItem("sessionData", JSON.stringify(userObj));
          // history.push("/admin/dashboard");
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const inputDigit = {
    width: "40px",
    height: "40px",
    fontSize: "20px",
    textAlign: "center",
    borderRadius: "8px",
    border: "1px solid #ccc",
  };

  const containerDigit = {
    display: "flex",
    gap: "10px",
    justifyContent: "center",
    marginTop: "20px",
    // marginLeft: "25px"
  };

  /*
  |--------------------------------------------------------------------------
  | Like / unlike
  |--------------------------------------------------------------------------
  */

  const toggleLike = async (postId) => {
    const post = posts.find((item) => item.id === postId);
    const registerId = userObj?.id;

    if (!post || !registerId) {
      return;
    }

    const oldIsLiked = Boolean(post.isLiked);
    const oldLikes = Number(post.likes) || 0;

    const newIsLiked = !oldIsLiked;
    const newLikes = newIsLiked ? oldLikes + 1 : Math.max(0, oldLikes - 1);

    setPosts((previousPosts) =>
      previousPosts.map((item) =>
        item.id === postId
          ? {
              ...item,
              isLiked: newIsLiked,
              likes: newLikes,
            }
          : item,
      ),
    );

    try {
      const response = await fetch(
        `${localApi}/posts/${postId}/like/${registerId}`,
        {
          method: newIsLiked ? "POST" : "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Basic ${credentials}`,
          },
        },
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || `HTTP ${response.status}`);
      }

      const result = await response.json();

      setPosts((previousPosts) =>
        previousPosts.map((item) =>
          item.id === postId
            ? {
                ...item,
                isLiked:
                  typeof result.liked === "boolean" ? result.liked : newIsLiked,
                likes:
                  result.likes !== undefined
                    ? Number(result.likes) || 0
                    : newLikes,
              }
            : item,
        ),
      );
    } catch (error) {
      console.error("toggleLike error:", error);

      setPosts((previousPosts) =>
        previousPosts.map((item) =>
          item.id === postId
            ? {
                ...item,
                isLiked: oldIsLiked,
                likes: oldLikes,
              }
            : item,
        ),
      );
    }
  };

  /*
  |--------------------------------------------------------------------------
  | Repost / unrepost
  |--------------------------------------------------------------------------
  */

  const toggleRepost = async (postId) => {
    const post = posts.find((item) => item.id === postId);
    const registerId = userObj?.id;

    if (!post || !registerId) {
      return;
    }

    const oldIsReposted =
      typeof post.isReposted === "boolean"
        ? post.isReposted
        : Boolean(post.isReposts);

    const oldReposts = Number(post.reposts) || 0;

    const newIsReposted = !oldIsReposted;
    const newReposts = newIsReposted
      ? oldReposts + 1
      : Math.max(0, oldReposts - 1);

    setPosts((previousPosts) =>
      previousPosts.map((item) =>
        item.id === postId
          ? {
              ...item,
              isReposted: newIsReposted,
              isReposts: newIsReposted,
              reposts: newReposts,
            }
          : item,
      ),
    );

    try {
      const response = await fetch(
        `${localApi}/posts/${postId}/reposts/${registerId}`,
        {
          method: newIsReposted ? "POST" : "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Basic ${credentials}`,
          },
        },
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || `HTTP ${response.status}`);
      }

      const result = await response.json();

      const serverIsReposted =
        typeof result.isReposted === "boolean"
          ? result.isReposted
          : typeof result.repost === "boolean"
          ? result.repost
          : typeof result.isReposts === "boolean"
          ? result.isReposts
          : newIsReposted;

      const serverReposts =
        result.reposts !== undefined ? Number(result.reposts) || 0 : newReposts;

      setPosts((previousPosts) =>
        previousPosts.map((item) =>
          item.id === postId
            ? {
                ...item,
                isReposted: serverIsReposted,
                isReposts: serverIsReposted,
                reposts: serverReposts,
              }
            : item,
        ),
      );
    } catch (error) {
      console.error("toggleRepost error:", error);

      setPosts((previousPosts) =>
        previousPosts.map((item) =>
          item.id === postId
            ? {
                ...item,
                isReposted: oldIsReposted,
                isReposts: oldIsReposted,
                reposts: oldReposts,
              }
            : item,
        ),
      );
    }
  };

  /*
  |--------------------------------------------------------------------------
  | Save / unsave
  |--------------------------------------------------------------------------
  */

  const toggleSave = async (postId) => {
    const post = posts.find((item) => item.id === postId);
    const registerId = userObj?.id;

    if (!post || !registerId) {
      return;
    }

    const oldIsSaved = Boolean(post.isSaved);
    const oldSave = Number(post.save) || 0;

    const newIsSaved = !oldIsSaved;
    const newSave = newIsSaved ? oldSave + 1 : Math.max(0, oldSave - 1);

    setPosts((previousPosts) =>
      previousPosts.map((item) =>
        item.id === postId
          ? {
              ...item,
              isSaved: newIsSaved,
              save: newSave,
            }
          : item,
      ),
    );

    try {
      const response = await fetch(
        `${localApi}/posts/${postId}/save/${registerId}`,
        {
          method: newIsSaved ? "POST" : "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Basic ${credentials}`,
          },
        },
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || `HTTP ${response.status}`);
      }

      const result = await response.json();

      setPosts((previousPosts) =>
        previousPosts.map((item) =>
          item.id === postId
            ? {
                ...item,
                isSaved:
                  typeof result.saved === "boolean" ? result.saved : newIsSaved,
                save:
                  result.save !== undefined
                    ? Number(result.save) || 0
                    : newSave,
              }
            : item,
        ),
      );
    } catch (error) {
      console.error("toggleSave error:", error);

      setPosts((previousPosts) =>
        previousPosts.map((item) =>
          item.id === postId
            ? {
                ...item,
                isSaved: oldIsSaved,
                save: oldSave,
              }
            : item,
        ),
      );
    }
  };

  /*
  |--------------------------------------------------------------------------
  | Comments
  |--------------------------------------------------------------------------
  */

  const openComments = (postId) => {
    const post = posts.find((item) => item.id === postId);

    if (!post) {
      return;
    }

    setSelectedPost(post);
    setCommentText("");
    setCommentError("");
    setCommentModalOpen(true);
  };

  const closeComments = () => {
    if (commentSaving || commentDeleting) {
      return;
    }

    setCommentModalOpen(false);
    setSelectedPost(null);
    setCommentText("");
    setCommentError("");
  };

  const addComment = async () => {
    const registerId = userObj?.id;
    const adminId = userObj.id ? userObj.admin.id : 2;
    const postId = selectedPost?.id;

    if (!postId || !registerId) {
      setCommentError("Please login first.");
      return;
    }

    const trimmedComment = commentText.trim();

    if (!trimmedComment) {
      setCommentError("Please enter a comment.");
      return;
    }

    setCommentSaving(true);
    setCommentError("");

    try {
      // Get user profile data
      const profileResponse = await fetch(
        `${localApi}/register/find/byId/${registerId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Basic ${credentials}`,
            Accept: "application/json",
          },
        },
      );

      if (!profileResponse.ok) {
        throw new Error(
          `Failed to get register data: HTTP ${profileResponse.status}`,
        );
      }

      const regData = await profileResponse.json();

      // Add comment
      const addCommentResponse = await fetch(
        `${localApi}/posts/addComment/${postId}/${registerId}/${adminId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Basic ${credentials}`,
            Accept: "application/json",
          },
          body: JSON.stringify({
            comment: trimmedComment,
            userName:
              userObj?.company ||
              userObj?.firstname ||
              userObj?.username ||
              "You",
            userProfile: null,
            rId: registerId,
          }),
        },
      );

      if (!addCommentResponse.ok) {
        const errorText = await addCommentResponse.text();
        throw new Error(errorText || `HTTP ${addCommentResponse.status}`);
      }

      const savedComment = await addCommentResponse.json();

      const newComment = {
        ...savedComment,
        id: savedComment?.id,
        comment: savedComment?.comment || trimmedComment,
        userName:
          savedComment?.userName ||
          userObj?.company ||
          userObj?.firstname ||
          userObj?.username ||
          "You",
        userProfile: savedComment?.userProfile || regData?.profileUrl || "",
        rId: savedComment?.rId || registerId,
        createdAt: savedComment?.createdAt,
      };

      /*
       * Update posts immediately.
       * The new comment is added at the top of the list.
       */
      setPosts((previousPosts) =>
        previousPosts.map((post) => {
          if (post.id !== postId) {
            return post;
          }

          const oldComments = Array.isArray(post.commentList)
            ? post.commentList
            : [];

          const updatedComments = [newComment, ...oldComments];

          return {
            ...post,
            commentList: updatedComments,
            comments: updatedComments.length,
          };
        }),
      );

      /*
       * Update selected post/modal immediately.
       */
      setSelectedPost((previousPost) => {
        if (!previousPost || previousPost.id !== postId) {
          return previousPost;
        }

        const oldComments = Array.isArray(previousPost.commentList)
          ? previousPost.commentList
          : [];

        const updatedComments = [newComment, ...oldComments];

        return {
          ...previousPost,
          commentList: updatedComments,
          comments: updatedComments.length,
        };
      });

      // Clear the input field
      setCommentText("");
    } catch (error) {
      console.error("addComment error:", error);
      setCommentError(error.message || "Failed to add comment.");
    } finally {
      setCommentSaving(false);
    }
  };

  const deleteComment = async (commentId) => {
    if (!commentId || !selectedPost?.id) {
      return;
    }

    setCommentDeleting(commentId);
    setCommentError("");

    try {
      const response = await fetch(
        `${localApi}/posts/deleteComment/${commentId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Basic ${credentials}`,
            Accept: "application/json",
          },
        },
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || `HTTP ${response.status}`);
      }

      // Remove the comment from the posts list
      setPosts((previousPosts) =>
        previousPosts.map((post) => {
          if (post.id !== selectedPost.id) {
            return post;
          }

          const oldComments = Array.isArray(post.commentList)
            ? post.commentList
            : [];

          const newComments = oldComments.filter(
            (comment) => String(comment.id) !== String(commentId),
          );

          return {
            ...post,
            commentList: newComments,
            comments: newComments.length,
          };
        }),
      );

      // Remove the comment from the currently opened modal
      setSelectedPost((previousPost) => {
        if (!previousPost) {
          return previousPost;
        }

        const oldComments = Array.isArray(previousPost.commentList)
          ? previousPost.commentList
          : [];

        const newComments = oldComments.filter(
          (comment) => String(comment.id) !== String(commentId),
        );

        return {
          ...previousPost,
          commentList: newComments,
          comments: newComments.length,
        };
      });
    } catch (error) {
      console.error("deleteComment error:", error);
      setCommentError(error.message || "Failed to delete comment.");
    } finally {
      setCommentDeleting(null);
    }
  };

  /*
  |--------------------------------------------------------------------------
  | Share
  |--------------------------------------------------------------------------
  */

  const openShare = async (post) => {
    const shareUrl = `${window.location.origin}/offer-list#${post.id}`;

    try {
      if (navigator.share) {
        await navigator.share({
          title: "INDIAN BANGLES Offer",
          text: post.description || "",
          url: shareUrl,
        });

        return;
      }

      if (navigator.clipboard) {
        await navigator.clipboard.writeText(shareUrl);
        alert("Offer link copied successfully.");
      }
    } catch (error) {
      console.log("Share was cancelled or unavailable.", error);
    }
  };

  /*
  |--------------------------------------------------------------------------
  | Call
  |--------------------------------------------------------------------------
  */

  const openCall = async (postId) => {
    const post = posts.find((item) => item.id === postId);

    if (!post) {
      return;
    }

    const oldCalls = Number(post.calls) || 0;

    setPosts((previousPosts) =>
      previousPosts.map((item) =>
        item.id === postId
          ? {
              ...item,
              calls: oldCalls + 1,
            }
          : item,
      ),
    );

    try {
      const response = await fetch(
        `${localApi}/posts/updateCallsCount/byId/${postId}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Basic ${credentials}`,
          },
        },
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || `HTTP ${response.status}`);
      }
    } catch (error) {
      console.error("openCall error:", error);

      setPosts((previousPosts) =>
        previousPosts.map((item) =>
          item.id === postId
            ? {
                ...item,
                calls: oldCalls,
              }
            : item,
        ),
      );
    }

    window.location.href = "tel:+919967427786";
  };

  /*
  |--------------------------------------------------------------------------
  | WhatsApp
  |--------------------------------------------------------------------------
  */

  const openWhatsApp = async (post) => {
    if (!post) {
      return;
    }

    const postId = post.id;
    const oldWhatsapps = Number(post.whatsapps) || 0;

    setPosts((previousPosts) =>
      previousPosts.map((item) =>
        item.id === postId
          ? {
              ...item,
              whatsapps: oldWhatsapps + 1,
            }
          : item,
      ),
    );

    try {
      const response = await fetch(
        `${localApi}/posts/updateWhatsappsCount/byId/${postId}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Basic ${credentials}`,
          },
        },
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || `HTTP ${response.status}`);
      }
    } catch (error) {
      console.error("openWhatsApp error:", error);

      setPosts((previousPosts) =>
        previousPosts.map((item) =>
          item.id === postId
            ? {
                ...item,
                whatsapps: oldWhatsapps,
              }
            : item,
        ),
      );
    }

    const messageText =
      `Hello, I am interested in this offer:\n\n` +
      `Post ID: ${postId}\n` +
      `Description: ${post.description || "N/A"}\n` +
      (post.category ? `Title: ${post.category}\n` : "") +
      (post.sizemm ? `Title: ${post.sizemm}\n` : "");

    const text = encodeURIComponent(messageText);

    window.open(
      `https://wa.me/919920246810?text=${text}`,
      "_blank",
      "noopener,noreferrer",
    );
  };

  /*
  |--------------------------------------------------------------------------
  | Image ribbon color
  |--------------------------------------------------------------------------
  */

  const handleImageLoad = (event, postId) => {
    try {
      const image = event.target;

      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");

      if (!context) {
        throw new Error("Canvas context is not available");
      }

      const sampleSize = 50;

      canvas.width = sampleSize;
      canvas.height = sampleSize;

      context.drawImage(image, 0, 0, sampleSize, sampleSize);

      const imageData = context.getImageData(0, 0, sampleSize, sampleSize);

      let redTotal = 0;
      let greenTotal = 0;
      let blueTotal = 0;
      let pixelCount = 0;

      for (let index = 0; index < imageData.data.length; index += 4) {
        const red = imageData.data[index];
        const green = imageData.data[index + 1];
        const blue = imageData.data[index + 2];
        const alpha = imageData.data[index + 3];

        if (alpha < 100) {
          continue;
        }

        if (red > 245 && green > 245 && blue > 245) {
          continue;
        }

        redTotal += red;
        greenTotal += green;
        blueTotal += blue;
        pixelCount += 1;
      }

      if (pixelCount === 0) {
        throw new Error("No usable image pixels");
      }

      const red = Math.round(redTotal / pixelCount);
      const green = Math.round(greenTotal / pixelCount);
      const blue = Math.round(blueTotal / pixelCount);

      setRibbonColors((previous) => ({
        ...previous,
        [postId]: `rgba(${red}, ${green}, ${blue}, 0.88)`,
      }));
    } catch (error) {
      setRibbonColors((previous) => ({
        ...previous,
        [postId]: "rgba(0, 0, 0, 0.55)",
      }));
    }
  };

  /*
  |--------------------------------------------------------------------------
  | Styles
  |--------------------------------------------------------------------------
  */

  const cardStyle = {
    width: "100%",
    height: "auto",
    margin: 0,
    borderRadius: 12,
    overflow: "hidden",
    backgroundColor: "#ffffff",
    boxShadow: "0 4px 14px rgba(0, 0, 0, 0.10)",
    display: "flex",
    flexDirection: "column",
  };

  const imageWrapperStyle = {
    position: "relative",
    height: 260,
    width: "100%",
    overflow: "hidden",
    background: "#f5f5f5",
    flexShrink: 0,
  };

  const imageStyle = {
    display: "block",
    width: "100%",
    height: "100%",
    objectFit: "cover",
  };

  const ribbonTopStyle = {
    position: "absolute",
    top: 12,
    left: "50%",
    transform: "translateX(-50%)",
    color: "#ffffff",
    padding: "6px 10px",
    borderRadius: 5,
    fontSize: 11,
    lineHeight: "14px",
    fontWeight: 700,
    whiteSpace: "nowrap",
    transition: "background 0.3s ease",
    zIndex: 2,
  };

  const ribbonBottomStyle = {
    position: "absolute",
    bottom: 12,
    left: 12,
    background: "rgba(218, 165, 32, 0.93)",
    color: "#111111",
    padding: "6px 14px",
    borderRadius: 5,
    fontSize: 12,
    lineHeight: "14px",
    fontWeight: 700,
    whiteSpace: "nowrap",
    zIndex: 2,
  };

  const ribbonCategoryStyle = {
    position: "absolute",
    top: "50%",
    right: 12,
    transform: "translateY(-50%)",
    background: "rgba(0, 0, 0, 0.55)",
    color: "#ffffff",
    padding: "6px 10px",
    borderRadius: 5,
    fontSize: 12,
    lineHeight: "14px",
    fontWeight: 700,
    textAlign: "center",
    whiteSpace: "nowrap",
    zIndex: 2,
  };

  const headerRowStyle = {
    display: "flex",
    alignItems: "center",
    minHeight: 65,
    padding: "12px 16px",
    background: "#fafafa",
    borderBottom: "1px solid #eeeeee",
    flexShrink: 0,
  };

  const actionsRowStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    minWidth: 0,
    minHeight: 52,
    padding: "6px 4px",
    boxSizing: "border-box",
    overflow: "hidden",
  };

  const leftActionsStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 2,
    flex: "1 1 auto",
    minWidth: 0,
    overflowX: "auto",
    overflowY: "hidden",
    scrollbarWidth: "none",
    WebkitOverflowScrolling: "touch",
  };

  const actionWithValueStyle = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 2,
    flex: "0 0 auto",
    minWidth: 0,
    margin: 0,
    padding: 0,
    whiteSpace: "nowrap",
  };

  const iconButtonStyle = {
    minWidth: 32,
    width: 32,
    height: 32,
    margin: 0,
    padding: 0,
    flexShrink: 0,
  };

  const saveButtonWrapperStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flex: "0 0 auto",
    minWidth: 32,
    marginLeft: 4,
  };

  const actionCountStyle = {
    display: "inline-block",
    color: "#444444",
    fontSize: 10,
    fontWeight: 600,
    lineHeight: "14px",
    margin: 0,
    padding: 0,
    whiteSpace: "nowrap",
    flexShrink: 0,
  };

  const captionStyle = {
    color: "#262626",
    fontSize: 13,
    lineHeight: "19px",
  };

  const hashtagStyle = {
    color: "#505050",
    fontSize: 13,
    lineHeight: "18px",
    marginTop: 2,
  };

  const metaRowStyle = {
    display: "flex",
    alignItems: "center",
    marginTop: 3,
  };

  const commentsButtonStyle = {
    padding: 0,
    border: "none",
    background: "transparent",
    color: "#8e8e8e",
    fontSize: 12,
    cursor: "pointer",
  };

  const timeStyle = {
    marginLeft: 8,
    color: "#8e8e8e",
    fontSize: 11,
  };

  /*
  |--------------------------------------------------------------------------
  | Comment modal styles
  |--------------------------------------------------------------------------
  */

  const commentDialogPaperStyle = {
    width: "100%",
    maxWidth: 520,
    borderRadius: 12,
    overflow: "hidden",
  };

  const commentHeaderStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "12px 16px",
    borderBottom: "1px solid #eeeeee",
  };

  const commentListStyle = {
    padding: "8px 0",
    maxHeight: 430,
    overflowY: "auto",
  };

  const commentItemStyle = {
    display: "flex",
    alignItems: "flex-start",
    padding: "10px 16px",
  };

  const commentAvatarStyle = {
    width: 36,
    height: 36,
    minWidth: 36,
    borderRadius: "50%",
    marginRight: 10,
    objectFit: "cover",
    border: "1px solid #eeeeee",
  };

  const commentAvatarFallbackStyle = {
    width: 36,
    height: 36,
    minWidth: 36,
    borderRadius: "50%",
    marginRight: 10,
    background: "#eeeeee",
    color: "#444444",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 12,
    fontWeight: 700,
  };

  const commentInputRowStyle = {
    display: "flex",
    alignItems: "center",
    padding: "10px 12px",
    borderTop: "1px solid #eeeeee",
    gap: 8,
  };

  /*
  |--------------------------------------------------------------------------
  | Render
  |--------------------------------------------------------------------------
  */

  return (
    <div className={classes.productPage}>
      <Helmet>
        <html lang="en" />
        <title>{seoTitle}</title>

        <meta name="description" content={seoDescription} />
        <meta name="keywords" content={seoKeywords} />
        <meta name="robots" content="index, follow" />

        <link rel="canonical" href={currentUrl} />

        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="INDIAN BANGLES" />
        <meta property="og:title" content={seoTitle} />
        <meta property="og:description" content={seoDescription} />
        <meta property="og:url" content={currentUrl} />
        <meta property="og:image" content={ogImage} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seoTitle} />
        <meta name="twitter:description" content={seoDescription} />
        <meta name="twitter:image" content={ogImage} />

        <script type="application/ld+json">
          {JSON.stringify(stockSchema)}
        </script>
      </Helmet>

      <InshaHeader
        brand="INSHA BANGLES PRIVATE LIMITED"
        links={<InshaHeaderLink dropdownHoverColor="dark" />}
        fixed
        color="dark"
        // color="transparent"
        // changeColorOnScroll={{
        //   height: 100,
        //   color: "dark",
        // }}
      />

      <Parallax
        image={require("assets/img/Product-Stock.jpg").default}
        filter="dark"
        className={classNames(classes.pageHeader, classes.hideParallaxMobile)}
      >
        <div className={classe.container}>
          <GridContainer justify="center">
            <GridItem
              md={8}
              sm={8}
              className={classNames(
                classe.mlAuto,
                classe.mrAuto,
                classe.textCenter,
              )}
            >
              <h1 className={classe.title} style={{ paddingTop: 100 }}>
                Ready Offer Bangles
              </h1>

              <h4 style={{ color: "#ffffff" }}>
                Explore our elegant ready stock bangles collection with
                different
                <br />
                designs, sizes, and colors available for immediate order.
              </h4>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>

      {!activeSession ? (
        <GridItem xs={12} sm={6} md={6} lg={6}>
          <Dialog
            classes={{
              root: classPop.modalRoot,
              paper: classPop.modal + " " + classPop.modalLogin,
            }}
            open={loginModal}
            TransitionComponent={Transition}
            keepMounted
            // onClose={() => setLoginModal(false)}
            aria-labelledby="login-modal-slide-title"
            aria-describedby="login-modal-slide-description"
          >
            <Card plain className={classPop.modalLoginCard}>
              <DialogTitle
                id="login-modal-slide-title"
                disableTypography
                className={classPop.modalHeader}
              >
                <CardHeader
                  plain
                  color="rose"
                  className={
                    classPop.textCenter + " " + classPop.cardLoginHeader
                  }
                >
                  <Button
                    simple
                    className={classPop.modalCloseButton}
                    key="close"
                    aria-label="Close"
                    onClick={() => {
                      setLoginModal(false);
                      // history.push(
                      //   `/size-mm-list?catdesc=${catdesc}&cat1desc=${cat1desc}&Plating=Gold%20Plating`,
                      // );
                    }}
                  >
                    {" "}
                    <Close className={classPop.modalClose} />
                  </Button>
                  <h5 className={classPop.cardTitleWhite}>Log in</h5>
                </CardHeader>
              </DialogTitle>
              <DialogContent
                id="login-modal-slide-description"
                className={classPop.modalBody}
              >
                {!otpScreen ? (
                  <form>
                    <p
                      className={
                        classPop.description + " " + classPop.textCenter
                      }
                    >
                      Welcome
                    </p>
                    <CardBody className={classPop.cardLoginBody}>
                      <GridContainer justify="center">
                        {/* <GridItem xs={12} sm={12} md={12}> */}
                        <NavPills
                          color="rose"
                          alignCenter
                          tabs={[
                            {
                              tabButton: "Mobile",
                              tabIcon: PhoneAndroidIcon,
                              tabContent: (
                                <>
                                  {/* <CardBody> */}
                                  <GridContainer>
                                    <GridItem xs={12} sm={12} md={12}>
                                      <PhoneInput
                                        inputStyle={{
                                          width: "100%",
                                          border: "none",
                                          borderBottom: "1px solid #040000 ",
                                          borderRadius: "0",
                                        }}
                                        country={"in"}
                                        name="mobile"
                                        value={mobile}
                                        // onChange={(mobile) => {
                                        //   handleMobileNumber(mobile);
                                        // }}
                                        onChange={(value, country) => {
                                          handleMobileNumber(
                                            value,
                                            country?.countryCode,
                                          );
                                        }}
                                        required={true}
                                      />
                                      <span style={{ color: "red" }}>
                                        {mobileErr}
                                      </span>
                                    </GridItem>
                                    {/* <Button
                                                  color="rose"
                                                  simple
                                                  // size="lg"
                                                  block
                                                  onClick={handleSendOtpWithMobile}
                                                >
                                                  Login
                                                </Button> */}
                                  </GridContainer>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      gap: "10px",
                                    }}
                                  >
                                    <Button
                                      color="rose"
                                      onClick={handleSendOtpWithMobile}
                                      style={{ flex: 1, width: 50 }}
                                    >
                                      Continue via OTP
                                    </Button>

                                    <Button
                                      color="rose"
                                      onClick={handleSendPasswordWithMobile}
                                      style={{ flex: 1, width: 50 }}
                                    >
                                      Continue via mPIN
                                    </Button>
                                  </div>
                                  {/* </CardBody> */}
                                  {/* <CardFooter
                                                className={
                                                  classe.justifyContentCenter
                                                }
                                              >
                                                <Button
                                                  color="rose"
                                                  simple
                                                  // size="lg"
                                                  block
                                                  onClick={handleSendOtpWithMobile}
                                                >
                                                  Login
                                                </Button>
                                              </CardFooter> */}
                                </>
                              ),
                            },
                            {
                              tabButton: "Email",
                              tabIcon: EmailIcon,
                              tabContent: (
                                <>
                                  {/* <CardBody> */}
                                  <GridContainer>
                                    <GridItem xs={12} sm={12} md={12}>
                                      <CustomInput
                                        formControlProps={{
                                          fullWidth: true,
                                          className:
                                            classes.customFormControlClasses,
                                        }}
                                        inputProps={{
                                          onChange: (e) => handleEmail(e),
                                          id: "email",
                                          value: email,
                                          name: "email",
                                          placeholder: "Email...",
                                        }}
                                        required={true}
                                      />
                                      <span style={{ color: "red" }}>
                                        {emailErr}
                                      </span>
                                    </GridItem>
                                    <Button
                                      color="rose"
                                      simple
                                      // size="lg"
                                      block
                                      onClick={handleSendOtpWithEmail}
                                    >
                                      Login
                                    </Button>
                                  </GridContainer>
                                  {/* </CardBody> */}
                                  {/* <CardFooter
                                                className={
                                                  classe.justifyContentCenter
                                                }
                                              >
                                                <Button
                                                  color="rose"
                                                  simple
                                                  // size="lg"
                                                  block
                                                  onClick={handleSendOtpWithEmail}
                                                >
                                                  Login
                                                </Button>
                                              </CardFooter> */}
                                </>
                              ),
                            },
                          ]}
                        />
                        {/* </GridItem> */}
                      </GridContainer>
                    </CardBody>
                    <br />
                    <div className={classes.textCenter}>
                      <h6>
                        Already have an account log in to Existing account
                      </h6>
                      <Button
                        simple
                        color="rose"
                        // size="lg"
                        href="/indian-register"
                      >
                        Create New Account
                      </Button>
                    </div>
                  </form>
                ) : (
                  <form>
                    {!forgotPass && !otpConfirm && !updatePassword && (
                      <>
                        <p
                          className={
                            classPop.description + " " + classPop.textCenter
                          }
                          style={{ marginLeft: "10px", marginRight: "10px" }}
                        >
                          6 digit {otpMpin} sent on your{" "}
                          {mobile ? "Mobile" : "Email"}
                          <br />
                          {mobile ? mobile : email}
                          {/* <br />{otp} {reSend} */}
                        </p>
                        <CardBody className={classPop.cardLoginBody}>
                          <div style={containerDigit}>
                            {password.map((digit, index) => (
                              <input
                                key={index}
                                ref={(el) => (inputs.current[index] = el)}
                                type="text"
                                inputMode="numeric"
                                maxLength={1}
                                value={digit}
                                onChange={(e) => {
                                  handlePasswordChange(e.target.value, index);
                                  setPasswordErr("");
                                }}
                                onKeyDown={(e) => handleKeyPress(e, index)}
                                style={inputDigit}
                              />
                            ))}
                          </div>
                          <p
                            className={
                              classes.description + " " + classes.textCenter
                            }
                            style={{ color: "red" }}
                          >
                            {otpNumberErr}
                          </p>
                        </CardBody>
                        <div
                          style={{
                            textAlign: "center", // centers inline content
                            display: "flex", // makes children flex items
                            justifyContent: "center", // horizontal center
                            alignItems: "center", // vertical center if needed
                            gap: "10px", // spacing between elements
                          }}
                        >
                          <Button
                            simple
                            color="rose"
                            // size="lg"
                            onClick={
                              mobile
                                ? otpMpin === "OTP"
                                  ? handleLoginWithMobile
                                  : handleLoginWithMobilePassword
                                : handleLoginWithEmail
                            }
                          >
                            Log in
                          </Button>
                          <Button
                            simple
                            color="rose"
                            // size="lg"
                            // onClick={handleCall}
                          >
                            <FiPhoneCall /> Call Me
                          </Button>
                        </div>

                        <p
                          className={classes.description}
                          style={{
                            textAlign: "center", // centers inline content
                            display: "flex", // makes children flex items
                            justifyContent: "center", // horizontal center
                            alignItems: "center", // vertical center if needed
                            gap: "10px", // spacing between elements
                          }}
                        >
                          {otpMpin === "OTP" ? (
                            <>
                              Didn{"'"}t receive the OTP yet?{" "}
                              <span style={{ marginLeft: "10px" }}>
                                <a
                                  // href="#"
                                  onClick={
                                    mobile
                                      ? handleSendOtpWithMobile
                                      : handleSendOtpWithEmail
                                  }
                                >
                                  Resend OTP
                                </a>
                              </span>{" "}
                            </>
                          ) : email ? (
                            ""
                          ) : (
                            <Button
                              color="transparent"
                              style={{
                                textTransform: "none",
                                textDecoration: "underline",
                                color: "red",
                              }}
                              onClick={() => setForgotPass((prev) => !prev)}
                            >
                              Forgot Password?
                            </Button>
                          )}
                        </p>
                      </>
                    )}

                    {/* EMAIL CONFIRM SECTION */}
                    {forgotPass && (
                      <CardBody style={{ textAlign: "center" }}>
                        <h5
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          Email Confirm
                        </h5>
                        <h6
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          Enter Your Email
                        </h6>
                        <CustomInput
                          formControlProps={{
                            fullWidth: true,
                            className: classes.customFormControlClasses,
                          }}
                          inputProps={{
                            onChange: (e) => handleEmailConfirm(e),
                            id: "emailConfirm",
                            value: emailConfirm,
                            name: "emailConfirm",
                            placeholder: "Email...",
                          }}
                          required={true}
                        />
                        <span style={{ color: "red" }}>{emailConfirmErr}</span>
                        <br />

                        <Button
                          color="transparent"
                          style={{
                            textTransform: "none",
                            justifyContent: "center",
                            alignItems: "center",
                            color: "red",
                          }}
                          onClick={async () => {
                            const getFindAdmin = admin?.find(
                              (f) => f.websitename === "indianbangles.in",
                            );
                            const api =
                              localApi + `/register/byEmail/${emailConfirm}`;
                            const result = await fetch(api, {
                              method: "GET",
                              headers: {
                                Authorization: `Basic ${credentials}`,
                              },
                            });
                            const getResult = await result.json();
                            fetch(
                              localApi +
                                `/register/send/byEmailaAndMobile?mobile=${mobile}&e=noreply@indianbangles.in`,

                              {
                                method: "POST",
                                headers: {
                                  "content-type": "application/json",
                                  accept: "application/json",
                                  Authorization: `Basic ${credentials}`,
                                },
                                body: JSON.stringify({
                                  to: emailConfirm,
                                  subject: "API CREATION SUBJECT",
                                  websitename: "indianbangles.in",
                                  followId: getFindAdmin.id,
                                  adminId: getResult.aId,
                                }),
                              },
                            )
                              .then((response) => response.json())
                              .then((res) => {
                                // console.log(res);

                                if (
                                  res.message ===
                                  "OTP Sent On Your Email ID Successfully"
                                ) {
                                  // ✅ Close forgotPass when OTP is confirmed
                                  setOtpConfirm(true);
                                  setForgotPass(false);
                                } else if (
                                  res.message ===
                                  "Your Email And Mobile not Match "
                                ) {
                                  setEmailConfirmErr(
                                    "Email & Mobile Not Match",
                                  );
                                }
                                // "Sender Not Found to +919967457786"
                              })
                              .catch((err) => {
                                console.log(err);
                              });
                          }}
                        >
                          Confirm Email
                        </Button>
                      </CardBody>
                    )}

                    {/* OTP CONFIRM SECTION */}
                    {otpConfirm && (
                      <CardBody style={{ textAlign: "center" }}>
                        <h5
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          Enter Verification Code
                        </h5>
                        <h6
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          For your Security we have sent the Code to your Email
                          <br />
                          {emailConfirm}
                        </h6>
                        <h6
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          Enter your 6-digit Code
                        </h6>

                        <div style={containerDigit}>
                          {passwordConfirm.map((digit, index) => (
                            <input
                              key={index}
                              ref={(el) => (inputsConfirm.current[index] = el)}
                              type="text"
                              inputMode="numeric"
                              maxLength={1}
                              value={digit}
                              onChange={(e) => {
                                handlePasswordChangeConfirm(
                                  e.target.value,
                                  index,
                                );
                                setPasswordConfirmErr("");
                              }}
                              onKeyDown={(e) => handleKeyPressConfirm(e, index)}
                              style={inputDigit}
                            />
                          ))}
                        </div>

                        <span style={{ color: "red" }}>
                          {passwordConfirmErr}
                        </span>
                        <br />

                        <Button
                          color="transparent"
                          style={{
                            textTransform: "none",
                            justifyContent: "center",
                            alignItems: "center",
                            color: "red",
                          }}
                          onClick={() => {
                            const password = passwordConfirm.join("");

                            if (password.length !== 6) {
                              setPasswordConfirmErr(
                                "mPIN must be exactly 6 digits.",
                              );
                              return;
                            }

                            fetch(
                              `${localApi}/register/recieved/byEmailAndMobile?email=${emailConfirm}&mobile=${mobile}&otp=${password}`,
                              {
                                method: "PUT",
                                headers: {
                                  Authorization: `Basic ${credentials}`,
                                },
                              },
                            )
                              .then((response) => response.json())
                              .then((response) => {
                                setPasswordConfirmErr(response.message);
                                if (
                                  response.message ===
                                  "Your Mobile And Email ID Match !!!"
                                ) {
                                  setUpdatePassword(true);
                                  setOtpConfirm(false);
                                }
                              })
                              .catch((err) => console.log(err));
                          }}
                        >
                          Confirm Code
                        </Button>
                        <br />

                        <Button
                          color="transparent"
                          style={{
                            textTransform: "none",
                            justifyContent: "center",
                            alignItems: "center",
                            color: "red",
                          }}
                          onClick={async () => {
                            const getFindAdmin = admin?.find(
                              (f) => f.websitename === "indianbangles.in",
                            );
                            const api =
                              localApi + `/register/byEmail/${emailConfirm}`;
                            const result = await fetch(api, {
                              method: "GET",
                              headers: {
                                Authorization: `Basic ${credentials}`,
                              },
                            });
                            const getResult = await result.json();
                            fetch(
                              localApi +
                                `/register/send/byEmailaAndMobile?mobile=${mobile}&e=noreply@indianbangles.in`,

                              {
                                method: "POST",
                                headers: {
                                  "content-type": "application/json",
                                  accept: "application/json",
                                  Authorization: `Basic ${credentials}`,
                                },
                                body: JSON.stringify({
                                  to: emailConfirm,
                                  subject: "API CREATION SUBJECT",
                                  websitename: "indianbangles.in",
                                  followId: getFindAdmin.id,
                                  adminId: getResult.aId,
                                }),
                              },
                            )
                              .then((response) => response.json())
                              .then((res) => {
                                //  console.log(res);

                                if (
                                  res &&
                                  res.message ===
                                    "OTP Sent On Your Email ID Successfully"
                                ) {
                                  setEmailConfirmErr(
                                    "OTP Resend On Your Email ID",
                                  );
                                }
                                // "Sender Not Found to +919967457786"
                              })
                              .catch((err) => {
                                console.log(err);
                              });
                          }}
                        >
                          Didn't receive the Code yet? <br /> Resend Code
                        </Button>
                      </CardBody>
                    )}

                    {/* UPDATE PASSWORD SECTION */}
                    {updatePassword && (
                      <CardBody style={{ textAlign: "center" }}>
                        <h5
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          Forgot mPIN
                        </h5>
                        <h6
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          Enter New 6-digit mPIN
                        </h6>

                        <div style={containerDigit}>
                          {updatePasswordConfirm.map((digit, index) => (
                            <input
                              key={index}
                              ref={(el) => (inputsUpdate.current[index] = el)}
                              type="text"
                              inputMode="numeric"
                              maxLength={1}
                              value={digit}
                              onChange={(e) => {
                                handlePasswordChangeConfirmUpdate(
                                  e.target.value,
                                  index,
                                );
                                setUpdatePasswordConfirmErr("");
                              }}
                              onKeyDown={(e) =>
                                handleKeyPressConfirmUpdate(e, index)
                              }
                              style={inputDigit}
                            />
                          ))}
                        </div>

                        <span style={{ color: "red" }}>
                          {updatePasswordConfirmErr}
                        </span>
                        <br />

                        <Button
                          color="transparent"
                          style={{
                            textTransform: "none",
                            justifyContent: "center",
                            alignItems: "center",
                            color: "red",
                          }}
                          onClick={async () => {
                            const password = updatePasswordConfirm.join("");

                            if (password.length !== 6) {
                              setUpdatePasswordConfirmErr(
                                "mPIN must be exactly 6 digits.",
                              );
                              return;
                            }

                            const requestOptions = {
                              method: "PUT",
                              headers: {
                                "Content-Type": "application/json",
                                Accept: "application/json",
                                Authorization: `Basic ${credentials}`,
                              },
                              body: JSON.stringify({ password }),
                            };

                            const response = await fetch(
                              `${localApi}/register/updatePassword/byMobile/${mobile}`,
                              requestOptions,
                            );
                            const data = await response.json();

                            if (
                              data.message === "Data Updated Successfully !!!"
                            ) {
                              window.location.reload(false);
                            }
                          }}
                        >
                          Update mPIN
                        </Button>
                      </CardBody>
                    )}
                  </form>
                )}
              </DialogContent>
            </Card>
          </Dialog>
        </GridItem>
      ) : (
        ""
      )}

      <div className={classNames(classes.section, classes.sectionGray)}>
        <div className={classes.container}>
          <div className={classes.relatedProducts}>
            <GridContainer>
              {posts.map((post) => {
                const endDate = post.endDate ? new Date(post.endDate) : null;

                const isOfferActive =
                  endDate && !Number.isNaN(endDate.getTime())
                    ? endDate.getTime() >= Date.now()
                    : false;

                const isReposted =
                  typeof post.isReposted === "boolean"
                    ? post.isReposted
                    : Boolean(post.isReposts);

                return (
                  <GridItem
                    key={post.id}
                    sm={6}
                    md={4}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      paddingLeft: 12,
                      paddingRight: 12,
                      paddingBottom: 24,
                    }}
                  >
                    <Card product>
                      {/* Header */}
                      <div style={headerRowStyle}>
                        <AvatarImage
                          src={post.avatarUrl}
                          company={post.company}
                        />

                        <div
                          style={{
                            flex: 1,
                            minWidth: 0,
                          }}
                        >
                          <div
                            style={{
                              color: "#262626",
                              fontSize: 14,
                              fontWeight: 600,
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {post.company || "Company"}
                          </div>

                          <div
                            style={{
                              marginTop: 2,
                              color: "#8e8e8e",
                              fontSize: 12,
                            }}
                          >
                            Mumbai, India
                          </div>
                        </div>

                        <Tooltip title="More options">
                          <Button
                            justIcon
                            simple
                            color="transparent"
                            type="button"
                          >
                            <MoreHoriz style={{ color: "#262626" }} />
                          </Button>
                        </Tooltip>
                      </div>

                      {/* Product image */}
                      <div style={imageWrapperStyle}>
                        {post.image ? (
                          <img
                            src={post.image}
                            alt={`${post.company || "Company"} offer`}
                            style={imageStyle}
                            onLoad={(event) => handleImageLoad(event, post.id)}
                            onError={() => {
                              setRibbonColors((previous) => ({
                                ...previous,
                                [post.id]: "rgba(0, 0, 0, 0.55)",
                              }));
                            }}
                          />
                        ) : (
                          <div
                            style={{
                              width: "100%",
                              height: "100%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color: "#777777",
                            }}
                          >
                            Image unavailable
                          </div>
                        )}

                        <div
                          style={{
                            ...ribbonTopStyle,
                            background:
                              ribbonColors[post.id] || "rgba(0, 0, 0, 0.55)",
                          }}
                        >
                          Metal ₹ {post.metal || 0} + Making ₹{" "}
                          {post.making || 0}
                        </div>

                        {isOfferActive && post.offer && (
                          <div style={ribbonBottomStyle}>{post.offer}</div>
                        )}

                        <div style={ribbonCategoryStyle}>
                          {post.category || ""}
                          <br />
                          {post.sizemm || ""}
                        </div>
                      </div>

                      {/* Actions */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          width: "100%",
                          minWidth: 0,
                          padding: "6px 10px 4px",
                          boxSizing: "border-box",
                          gap: 4,
                        }}
                      >
                        {/* Left actions */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            flex: "1 1 auto",
                            minWidth: 0,
                            flexWrap: "wrap",
                            gap: "1px 4px",
                            overflow: "hidden",
                          }}
                        >
                          {/* Like */}
                          <div
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              flex: "0 0 auto",
                              minWidth: 0,
                            }}
                          >
                            <Tooltip title={post.isLiked ? "Unlike" : "Like"}>
                              <Button
                                justIcon
                                simple
                                color="transparent"
                                type="button"
                                style={{
                                  width: 30,
                                  height: 30,
                                  minWidth: 30,
                                  padding: 0,
                                  margin: 0,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                                onClick={() => {
                                  if (!userObj?.id) {
                                    setLoginModal(true);
                                  } else {
                                    toggleLike(post.id);
                                  }
                                }}
                              >
                                {post.isLiked ? (
                                  <Favorite
                                    style={{
                                      color: "#ed4956",
                                      fontSize: 20,
                                    }}
                                  />
                                ) : (
                                  <FavoriteBorder
                                    style={{
                                      color: "#262626",
                                      fontSize: 20,
                                    }}
                                  />
                                )}
                              </Button>
                            </Tooltip>

                            <span
                              style={{
                                fontSize: 11,
                                color: "#444444",
                                lineHeight: 1,
                                whiteSpace: "nowrap",
                              }}
                            >
                              {Number(post.likes) || 0}
                            </span>
                          </div>

                          {/* Comments */}
                          <div
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              flex: "0 0 auto",
                              minWidth: 0,
                            }}
                          >
                            <Tooltip title="Comments">
                              <Button
                                justIcon
                                simple
                                color="transparent"
                                type="button"
                                style={{
                                  width: 30,
                                  height: 30,
                                  minWidth: 30,
                                  padding: 0,
                                  margin: 0,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                                onClick={() => {
                                  if (!userObj?.id) {
                                    setLoginModal(true);
                                  } else {
                                    openComments(post.id);
                                  }
                                }}
                              >
                                <ChatBubbleOutline
                                  style={{
                                    color: "#262626",
                                    fontSize: 20,
                                  }}
                                />
                              </Button>
                            </Tooltip>

                            <span
                              style={{
                                fontSize: 11,
                                color: "#444444",
                                lineHeight: 1,
                                whiteSpace: "nowrap",
                              }}
                            >
                              {Number(post.comments) || 0}
                            </span>
                          </div>

                          {/* Repost */}
                          <div
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              flex: "0 0 auto",
                              minWidth: 0,
                            }}
                          >
                            <Tooltip
                              title={isReposted ? "Remove repost" : "Repost"}
                            >
                              <Button
                                justIcon
                                simple
                                color="transparent"
                                type="button"
                                style={{
                                  width: 30,
                                  height: 30,
                                  minWidth: 30,
                                  padding: 0,
                                  margin: 0,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                                onClick={() => {
                                  if (!userObj?.id) {
                                    setLoginModal(true);
                                  } else {
                                    toggleRepost(post.id);
                                  }
                                }}
                              >
                                <Repeat
                                  style={{
                                    color: isReposted ? "#1b8f3a" : "#262626",
                                    fontSize: 20,
                                  }}
                                />
                              </Button>
                            </Tooltip>

                            <span
                              style={{
                                fontSize: 11,
                                color: isReposted ? "#1b8f3a" : "#444444",
                                lineHeight: 1,
                                whiteSpace: "nowrap",
                              }}
                            >
                              {Number(post.reposts) || 0}
                            </span>
                          </div>

                          {/* Share */}
                          <div
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              flex: "0 0 auto",
                              minWidth: 0,
                            }}
                          >
                            <Tooltip title="Share">
                              <Button
                                justIcon
                                simple
                                color="transparent"
                                type="button"
                                style={{
                                  width: 30,
                                  height: 30,
                                  minWidth: 30,
                                  padding: 0,
                                  margin: 0,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                                onClick={() => openShare(post)}
                              >
                                <ShareOutlined
                                  style={{
                                    color: "#262626",
                                    fontSize: 20,
                                  }}
                                />
                              </Button>
                            </Tooltip>
                          </div>

                          {/* Calls */}
                          <div
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              flex: "0 0 auto",
                              minWidth: 0,
                            }}
                          >
                            <Tooltip title="Call">
                              <Button
                                justIcon
                                simple
                                color="transparent"
                                type="button"
                                style={{
                                  width: 30,
                                  height: 30,
                                  minWidth: 30,
                                  padding: 0,
                                  margin: 0,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                                // onClick={() => openCall(post.id)}
                                onClick={() => {
                                  if (!userObj?.id) {
                                    setLoginModal(true);
                                  } else {
                                    openCall(post.id);
                                  }
                                }}
                              >
                                <Phone
                                  style={{
                                    color: "#262626",
                                    fontSize: 20,
                                  }}
                                />
                              </Button>
                            </Tooltip>

                            <span
                              style={{
                                fontSize: 11,
                                color: "#444444",
                                lineHeight: 1,
                                whiteSpace: "nowrap",
                              }}
                            >
                              {Number(post.calls) || 0}
                            </span>
                          </div>

                          {/* WhatsApp */}
                          <div
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              flex: "0 0 auto",
                              minWidth: 0,
                            }}
                          >
                            <Tooltip title="WhatsApp">
                              <Button
                                justIcon
                                simple
                                color="transparent"
                                type="button"
                                style={{
                                  width: 30,
                                  height: 30,
                                  minWidth: 30,
                                  padding: 0,
                                  margin: 0,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                                onClick={() => openWhatsApp(post)}
                              >
                                <WhatsApp
                                  style={{
                                    color: "#25D366",
                                    fontSize: 20,
                                  }}
                                />
                              </Button>
                            </Tooltip>

                            <span
                              style={{
                                fontSize: 11,
                                color: "#444444",
                                lineHeight: 1,
                                whiteSpace: "nowrap",
                              }}
                            >
                              {Number(post.whatsapps) || 0}
                            </span>
                          </div>
                        </div>

                        {/* Save */}
                        <div
                          style={{
                            flex: "0 0 auto",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginLeft: 2,
                          }}
                        >
                          <Tooltip title={post.isSaved ? "Unsave" : "Save"}>
                            <Button
                              justIcon
                              simple
                              color="transparent"
                              type="button"
                              style={{
                                width: 30,
                                height: 30,
                                minWidth: 30,
                                padding: 0,
                                margin: 0,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                              onClick={() => {
                                if (!userObj?.id) {
                                  setLoginModal(true);
                                } else {
                                  toggleSave(post.id);
                                }
                              }}
                            >
                              {post.isSaved ? (
                                <Bookmark
                                  style={{
                                    color: "#262626",
                                    fontSize: 20,
                                  }}
                                />
                              ) : (
                                <BookmarkBorder
                                  style={{
                                    color: "#262626",
                                    fontSize: 20,
                                  }}
                                />
                              )}
                            </Button>
                          </Tooltip>
                        </div>
                      </div>

                      {/* Caption */}
                      <CardBody
                        style={{
                          paddingTop: 2,
                          paddingRight: 16,
                          paddingBottom: 0,
                          paddingLeft: 16,
                        }}
                      >
                        <div style={captionStyle}>
                          <span
                            style={{
                              fontWeight: 600,
                              marginRight: 5,
                            }}
                          >
                            {post.company || "Company"}
                          </span>

                          {post.description || ""}
                        </div>

                        <span>
                          {post.category || ""}
                          {post.category || post.sizemm ? ", " : ""}
                          {post.sizemm || ""}
                          {post.metalGram !== undefined
                            ? `, Metal Gram ${post.metalGram}`
                            : ""}
                          {post.readyGram !== undefined
                            ? `, Ready Gram ${post.readyGram}`
                            : ""}
                        </span>

                        {post.hashtag && (
                          <div style={hashtagStyle}>{post.hashtag}</div>
                        )}

                        <div style={metaRowStyle}>
                          <button
                            type="button"
                            onClick={() => openComments(post.id)}
                            style={commentsButtonStyle}
                          >
                            View all {Number(post.comments) || 0} comments
                          </button>

                          {post.timeAgo && (
                            <span style={timeStyle}>{post.timeAgo}</span>
                          )}
                        </div>
                      </CardBody>
                    </Card>
                  </GridItem>
                );
              })}
            </GridContainer>
          </div>

          {/*
    |-------------------------------------------------------------------------- 
    | Comments Dialog
    |-------------------------------------------------------------------------- 
    */}

          <Dialog
            open={commentModalOpen}
            onClose={closeComments}
            fullWidth
            maxWidth="sm"
            PaperProps={{
              style: commentDialogPaperStyle,
            }}
          >
            {/* Comment header */}
            <DialogTitle disableTypography style={commentHeaderStyle}>
              <div
                style={{
                  fontSize: 17,
                  fontWeight: 600,
                  color: "#262626",
                }}
              >
                Comments
                {selectedPost && (
                  <span
                    style={{
                      marginLeft: 6,
                      color: "#8e8e8e",
                      fontSize: 13,
                      fontWeight: 400,
                    }}
                  >
                    {Number(selectedPost.comments) || 0}
                  </span>
                )}
              </div>

              <IconButton
                size="small"
                onClick={closeComments}
                disabled={commentSaving || commentDeleting}
              >
                <Close />
              </IconButton>
            </DialogTitle>

            <DialogContent
              style={{
                padding: 0,
              }}
            >
              {/* Comments list */}
              <div style={commentListStyle}>
                {selectedPost &&
                Array.isArray(selectedPost.commentList) &&
                selectedPost.commentList.length > 0 ? (
                  selectedPost.commentList.map((comment) => {
                    const commentRId = comment.rId;
                    const commentdate = comment.createdAt;
                    // console.log(commentdate);

                    const commentUserName =
                      comment.userName || comment.company || "";

                    const commentProfile =
                      comment.userProfile || comment.avatarUrl || "";

                    const commentTextValue = comment.comment || "";

                    // Check whether comment is still within 1 hour
                    const commentTime = comment.createdAt
                      ? new Date(comment.createdAt).getTime()
                      : 0;

                    const currentTime = Date.now();

                    const oneHour = 60 * 60 * 1000;

                    const isWithinOneHour =
                      commentTime > 0 &&
                      currentTime - commentTime < oneHour &&
                      currentTime >= commentTime;

                    return (
                      <div key={comment.id} style={commentItemStyle}>
                        {commentProfile ? (
                          <img
                            src={commentProfile}
                            alt={commentUserName}
                            style={commentAvatarStyle}
                            onError={(event) => {
                              event.currentTarget.style.display = "none";

                              if (event.currentTarget.nextSibling) {
                                event.currentTarget.nextSibling.style.display =
                                  "flex";
                              }
                            }}
                          />
                        ) : null}

                        <div
                          style={{
                            ...commentAvatarFallbackStyle,
                            display: commentProfile ? "none" : "flex",
                          }}
                        >
                          {getInitials(commentUserName)}
                        </div>

                        <div
                          style={{
                            flex: 1,
                            minWidth: 0,
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <span
                              style={{
                                color: "#262626",
                                fontSize: 13,
                                fontWeight: 600,
                              }}
                            >
                              {commentUserName}
                            </span>

                            {String(commentRId) === String(userObj?.id) &&
                              isWithinOneHour && (
                                <IconButton
                                  size="small"
                                  onClick={() => deleteComment(comment.id)}
                                  disabled={commentDeleting === comment.id}
                                  style={{ padding: 4 }}
                                >
                                  {commentDeleting === comment.id ? (
                                    <CircularProgress size={16} />
                                  ) : (
                                    <Delete
                                      style={{
                                        fontSize: 18,
                                        color: "#999999",
                                      }}
                                    />
                                  )}
                                </IconButton>
                              )}
                          </div>

                          <div
                            style={{
                              marginTop: 3,
                              color: "#262626",
                              fontSize: 13,
                              lineHeight: "19px",
                              wordBreak: "break-word",
                            }}
                          >
                            {commentTextValue}
                          </div>

                          {comment.createdAt && (
                            <div
                              style={{
                                marginTop: 3,
                                color: "#999999",
                                fontSize: 10,
                              }}
                            >
                              {new Date(comment.createdAt).toLocaleString()}
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div
                    style={{
                      padding: "45px 20px",
                      textAlign: "center",
                      color: "#999999",
                      fontSize: 13,
                    }}
                  >
                    No comments yet.
                    <br />
                    Be the first to comment.
                  </div>
                )}
              </div>

              {/* Error */}
              {commentError && (
                <div
                  style={{
                    padding: "4px 16px 8px",
                    color: "#d32f2f",
                    fontSize: 12,
                  }}
                >
                  {commentError}
                </div>
              )}
            </DialogContent>

            {/* Add comment */}
            <DialogActions
              style={{
                padding: 0,
                display: "block",
              }}
            >
              <div style={commentInputRowStyle}>
                <TextField
                  fullWidth
                  variant="outlined"
                  size="small"
                  placeholder="Add a comment..."
                  value={commentText}
                  onChange={(event) => {
                    setCommentText(event.target.value);

                    if (commentError) {
                      setCommentError("");
                    }
                  }}
                  onKeyDown={(event) => {
                    if (event.key === "Enter" && !event.shiftKey) {
                      event.preventDefault();

                      if (!commentSaving) {
                        addComment();
                      }
                    }
                  }}
                  disabled={commentSaving}
                  inputProps={{
                    maxLength: 1000,
                  }}
                />

                <IconButton
                  color="primary"
                  onClick={addComment}
                  disabled={
                    commentSaving || !commentText.trim() || !userObj?.id
                  }
                >
                  {commentSaving ? <CircularProgress size={22} /> : <Send />}
                </IconButton>
              </div>
            </DialogActions>
          </Dialog>
        </div>
      </div>
      <Footer />
    </div>
  );
}
